import { z } from 'zod';

export const AssetSimplificationSchema = z
  .object({
    meshDecimation: z.object({
      method: z.union([
        z.literal('rebake'),
        z.literal('remeshing-keep-alpha'),
        z.literal('remeshing-bake-alpha'),
        z.literal('preserveTiling'),
        z.literal('rebakePreserveNodes'),
        z.literal('preserveUVsAndNodes'),
        z.literal('dropTextures'),
      ]),
    }),
    topologySettings: z.object({
      vertexMergingDistance: z.number().gte(0).lte(0.1),
      meshDensityEqualization: z.number().gte(0).lte(1),
      boundaryPreservationFactor: z.number().gte(0).lte(1).optional(),
      preserveTopology: z.boolean(),
    }),
    uvAndAtlasSettings: z.object({
      uvStretchTolerance: z.number().gte(0).lte(1),
      atlasingFactor: z.number().gte(1).lte(20),
    }),
    materialAndTextureBaking: z.object({
      bakingQuality: z.union([z.literal('low'), z.literal('medium'), z.literal('high')]),
      bakeNormalMap: z.boolean(),
      bakeAOMap: z.boolean(),
      aoStrength: z.number().gte(0).lte(1).optional(),
      normalsShading: z.number().gte(0).lte(180).optional(),
      alphaBlendToMask: z.boolean(),
      alphaMapToOpaqueThreshold: z.number().gte(0).lte(1).optional(),
    }),
  })
  .optional();
